export function validatedEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let isValid =  re.test(String(email).toLowerCase());

    if (isValid) return String(email).toLowerCase();
    return null;
}